import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from "@sentry/angular";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Elementos necesarios para Cordova.getPhoto()
import { defineCustomElements } from '@ionic/pwa-elements/loader';

// OPCIÓN DEIMPORTACIÓN POR MÓDULOS QUE NO ESTÁN HECHO CON IVY
// import '@angular/compiler';


if (environment.production) {
   // MOBILE APPS
   if (environment.isMobile) {
      document.addEventListener('deviceready', () => {
         // Now safe to use device APIs
         // window.location.href = "/";
         // setTimeout(() => {
         //    (navigator as any).splashscreen?.hide();
         // }, 250);
      }, false);

      document.addEventListener('backbutton', () => {
         // Handle the back button
         history.back();
      }, false);

      Sentry.init({
         dsn: "https://8b31827719e6cdd46ffa587c7135cb7f@o4509483835195392.ingest.us.sentry.io/4509483882512384",
         sendDefaultPii: true,
         tracesSampleRate: 0.5,
         tracePropagationTargets: [
            /^https:\/\/api\.monific\.com\/.*/,
            /^https:\/\/static\.monific\.monific\.com\//
         ],
         profilesSampleRate: 0.5,
         integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.browserProfilingIntegration(),
         ],

      });

      //  Sentry.init({
      //    release: 'monific-app@' + environment.version,
      //    dsn: 'https://3b4d47b2db424abb8b630675f9fb29fe@o1043447.ingest.sentry.io/6013031',
      //    integrations: [
      //      new Integrations.BrowserTracing({
      //        tracingOrigins: ['https://monific.com', 'https://app.monific.com', 'https://api.monific.com'],
      //        routingInstrumentation: Sentry.routingInstrumentation,
      //      }),
      //    ],

      //    // Set tracesSampleRate to 1.0 to capture 100%
      //    // of transactions for performance monitoring.
      //    // We recommend adjusting this value in production
      //    tracesSampleRate: 0.5,
      //  });
   }
   enableProdMode();
}


const bootstrap = () => {
   platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.error(err));
   // Call the element loader after the platform has been bootstrapped
   if (environment.isMobile) {
      defineCustomElements(window);
   }
}

if (typeof window['cordova'] !== 'undefined') {
   console.log(window['cordova']);

   document.addEventListener('deviceready', () => {
      (window as any).open = (window as any)['cordova']?.InAppBrowser ? (window as any)['cordova']?.InAppBrowser.open : window.open;
      bootstrap();
   }, false);
} else {
   bootstrap();
}
